var React = require("react");
var $ = require('jquery');

import { removeHtmlCode } from '../../../shared/mixin';

var classnames = require('classnames');

var HTMLEllipsis                  = require("react-lines-ellipsis/lib/html");
const Ellipsis = ({ text, maxLines = 3 }) =>
  <HTMLEllipsis unsafeHTML={text} maxLine={maxLines} ellipsisHTML={'...'} basedOn='letters'/>;

var ChallengeCardDetails = React.createClass({
  propTypes : {
    maxLines: React.PropTypes.number,
    onChange: React.PropTypes.func
  },

  getDefaultProps: function () {
    return {
      maxLines: 3,
      onChange: function() {}
    };
  },

  render : function(){
    return (
      <div className="challenge-details card__details">
        {this._addChildren()}
      </div>
    );
  },

  _addChildren: function() {
    var that = this;
    return React.Children.map(this.props.children, function(child){

      if( child && child.type.displayName === "ChallengeCardDetails.Headline" ){
        return React.cloneElement(child, {onChange: that.props.onChange});
      }

      return child;
    });
  },

});

ChallengeCardDetails.Headline = React.createClass({
  displayName: 'ChallengeCardDetails.Headline',
  propTypes : {
    headline : React.PropTypes.string,
    maxLines: React.PropTypes.number,
    onChange : React.PropTypes.func,
    shortCardDesignEnabled: React.PropTypes.bool,
    rewriteLook: React.PropTypes.bool
  },

  getDefaultProps : function(){
    return {
      headline : "",
      onChange : function(){}
    };
  },

  componentDidUpdate: function(nextProps){
    if (this.props.headline !== nextProps.headline) {
      this.props.onChange();
    }
  },

  render : function(){
    return (
      <h3
        className={classnames({
          'card__headline': true,
          'card__headline_old': !this.props.shortCardDesignEnabled,
          'card__headline__rewrite': this.props.rewriteLook
        })}
        ref="headline">
        <Ellipsis
          text={removeHtmlCode(this.props.headline).substr(0, 100)}
          maxLines={this.props.shortCardDesignEnabled ? 3 : 2} />
      </h3>
    );
  }
});

ChallengeCardDetails.Label = React.createClass({
  displayName: 'ChallengeCardDetails.Label',

  propTypes : {
    label : React.PropTypes.string,
    shortCardDesignEnabled: React.PropTypes.bool,
    rewriteLook: React.PropTypes.bool
  },

  render: function(){
    return (
      <div className={classnames({
        "challenge-card__label": true,
        "challenge-card__label_old": !this.props.shortCardDesignEnabled,
        "challenge-card__label__rewrite": this.props.rewriteLook
      })}>
        { this.props.label }
      </div>
    );
  }
});

ChallengeCardDetails.Description = React.createClass({
  displayName: 'ChallengeCardDetails.Description',

  propTypes : {
    description : React.PropTypes.string,
    maxLines: React.PropTypes.number,
    onChange: React.PropTypes.func
  },

  getDefaultProps : function(){
    return {
      description : "",
      maxLines: 3,
      onChange: function() {}
    };
  },

  componentDidUpdate: function(nextProps){
    if (this.props.description !== nextProps.description) {
      this.props.onChange();
    }
  },


  render: function(){
    if(this.props.description === null) return null;

    return (
      <div ref="description" className={this._getDescriptionClasses()}>
        <Ellipsis text={this._sanitizeDescription()} maxLines={this.props.maxLines}/>
      </div>
    );
  },

  _getDescriptionClasses: function() {
    return classnames('card_description', 'card__description',
    {
      'hide' : this.props.maxLines < 1
    });
  },

  _sanitizeDescription: function (){
    var e = document.createElement('div');

    e.innerHTML = this.props.description;
    return Array
      .from(e.childNodes, p => p.textContent).filter(t => t.length > 0).join(' ').trim()
      .substr(0, 200);
  }
});

module.exports = ChallengeCardDetails;



// WEBPACK FOOTER //
// ./src/advocate/challenges/components/challenge_card_details.jsx